// Import core library
import { library } from '@fortawesome/fontawesome-svg-core';

// Brands
import {
	faFacebook,
	faFlickr,
	faGoogle,
	faReddit,
	faInstagram,
	faMeetup,
	faTumblr,
	faTwitter,
	faVimeo,
	faYoutube,
	faWordpress
} from '@fortawesome/free-brands-svg-icons';

// Pro regular
import {
	faLongArrowLeft,
	faMap,
	faClock,
	faBars,
	faArrowToRight,
	faArrowToLeft,
	faArrowRight as farArrowRight,
	faPlus,
	faExternalLinkSquare,
	faTimes as faTimesRegular,
	faCircle as faCircleRegular,
	faAngleDown,
	faAngleUp,
	faSortAmountUp,
	faSortAmountDown,
	faSortAlphaUp,
	faSortAlphaDown,
	faLongArrowAltUp,
	faLongArrowAltDown,
	faAngleRight,
	faAt,
	faEnvelope as faEnvelopeRegular,
	faMapMarkerAlt as faMapMarkerAltRegular,
	faUsers,
	faUser as faUserRegular,
	faCommentsAlt,
	faSlidersH,
	faQuestionCircle,
	faCalendarStar,
	faTasks,
	faCloudDownloadAlt,
	faCalendarAlt,
	faArrowCircleUp,
	faArrowCircleDown,
	faMinusCircle,
	faExclamationCircle,
	faPlusCircle
} from '@fortawesome/pro-regular-svg-icons';

// Pro solid
import {
	faUser as faUserSolid,
	faPhone,
	faBullhorn,
	faEnvelope,
	faArrowRight,
	faArrowLeft,
	faBookmark as faBookmarkSolid,
	faCircle as faCircleSolid,
	faTrashAlt as faTrashAltSolid,
	faShare as faShareSolid,
	faComment as faCommentSolid,
	faCommentAltLines as faCommentAltLinesSolid,
	faArrowAltCircleUp as faArrowAltCircleUpSolid,
	faMale as faMaleSolid,
	faEnvelope as faEmailSolid,
	faChevronCircleUp as faChevronUpSolid,
	faChevronCircleDown as faChevronDownSolid,
	faMinusCircle as faMinusCircleSolid,
	faTh,
	faWifi,
	faChevronRight,
	faSortAlt as faSortAltSolid,
	faAbacus as faAbacusSolid,
	faBinoculars as faBinocularsSolid,
	faEye as faEyeSolid,
	faEngineWarning as faEngineWarningSolid,
	faCheckCircle as faCheckCircleSolid,
	faArrowFromLeft as faArrowFromLeftSolid,
	faTimesCircle as faTimesCircleSolid,
	faFolderUpload as faFolderUploadSolid,
	faExclamationCircle as faExclamationCircleSolid,
	faCog as faCogSolid,
	faUserCircle as faUserCircleSolid,
	faPaperPlane as faPaperPlaneSolid,
	faThumbsUp as faThumbsUpSolid,
	faSignal as faSignalSolid,
	faClock as faClockSolid,
	faMobileAlt as faMoblieAltSolid,
	faCheck as faCheckSolid,
	faExclamationTriangle as faExclamationTriangleSolid,
	faCommentAltDots as faCommentAltDotsSolid,
	faCommentsAlt as faCommentsAltSolid,
	faBell as faBellSolid
} from '@fortawesome/pro-solid-svg-icons';

// Pro light
import {
	faPaperPlane,
	faSearch,
	faShare,
	faMapMarkerAlt as faMapMarkerAltLight,
	faTrashAlt,
	faEllipsisV,
	faUser as faUserLight,
	faTimes as faTimesLight,
	faBookmark as faBookmarkLight,
	faGlobe,
	faCamera,
	faImages,
	faAngleDown as faAngleDownLight,
	faSortAmountUp as faSortAmountUpLight,
	faSortAmountDown as faSortAmountDownLight,
	faSortAlphaUp as faSortAlphaUpLight,
	faSortAlphaDown as faSortAlphaDownLight,
	faLongArrowAltUp as faLongArrowAltUpLight,
	faLongArrowAltDown as faLongArrowAltDownLight,
	faEnvelope as faEmailLight,
	faCommentsAlt as faCommentsAltLight,
	faCommentAltSmile,
	faArrowUp as faArrowUpLight,
	faArrowDown as faArrowDownLight,
	faListAlt as faListAltLight,
	faFilePdf as faFilePdfLight,
	faCog as faCogLight,
	faBuilding as faBuildingLight,
	faAbacus as faAbacusLight,
	faExclamationCircle as faExclamationCircleLight,
	faThumbsUp as faThumbsUpLight,
	faSignal as faSignalLight,
	faCheck as faCheckLight,
	faClock as faClockLight,
} from '@fortawesome/pro-light-svg-icons';

// Duo tone
import {
	faCheckCircle,
	faMailBulk as faMailBulkDuo,
	faSms as faSmsDuo,
	faFileAlt as faFileAltDuo,
	faSignalStream as faSignalStreamDuo,
	faSatelliteDish as faSatelliteDishDuo,
	faAbacus as faAbacusDuo,
	faCalendarAlt as faCalendarDuo,
	faEnvelope as faEmailDuo,
	faFolderUpload as faFolderUploadDuo,
	faCommentDots as faCommentDotsDuo,
	faBraille as faBrailleDuo,
	faExclamationTriangle as faExclamationTriangleDuo,
	faEnvelope as faEnvelopeDuo,
	faComments as faCommentsDuo
} from '@fortawesome/pro-duotone-svg-icons';

library.add(
	// Brands
	faFacebook,
	faFlickr,
	faGoogle,
	faReddit,
	faInstagram,
	faMeetup,
	faTumblr,
	faTwitter,
	faVimeo,
	faYoutube,
	faWordpress,

	// Pro regular
	faLongArrowLeft,
	faMap,
	faClock,
	faBars,
	faArrowToRight,
	faArrowToLeft,
	farArrowRight,
	faPlus,
	faExternalLinkSquare,
	faTimesRegular,
	faCircleRegular,
	faAngleDown,
	faAngleUp,
	faSortAmountUp,
	faSortAmountDown,
	faSortAlphaUp,
	faSortAlphaDown,
	faLongArrowAltUp,
	faLongArrowAltDown,
	faAngleRight,
	faAt,
	faEnvelopeRegular,
	faMapMarkerAltRegular,
	faUsers,
	faUserRegular,
	faBullhorn,
	faCommentsAlt,
	faSlidersH,
	faQuestionCircle,
	faTasks,
	faCalendarStar,
	faCloudDownloadAlt,
	faCalendarAlt,
	faArrowCircleUp,
	faArrowCircleDown,
	faMinusCircle,
	faExclamationCircle,
	faPlusCircle,

	// Pro solid
	faUserSolid,
	faPhone,
	faEnvelope,
	faArrowRight,
	faArrowLeft,
	faBookmarkSolid,
	faCircleSolid,
	faTrashAltSolid,
	faShareSolid,
	faCommentSolid,
	faMaleSolid,
	faChevronUpSolid,
	faChevronDownSolid,
	faMinusCircleSolid,
	faTh,
	faWifi,
	faChevronRight,
	faSortAltSolid,
	faAbacusSolid,
	faBinocularsSolid,
	faEyeSolid,
	faEngineWarningSolid,
	faCheckCircleSolid,
	faArrowFromLeftSolid,
	faTimesCircleSolid,
	faFolderUploadSolid,
	faExclamationCircleSolid,
	faCogSolid,
	faUserCircleSolid,
	faPaperPlaneSolid,
	faThumbsUpSolid,
	faSignalSolid,
	faClockSolid,
	faMoblieAltSolid,
	faCheckSolid,
	faExclamationTriangleSolid,
	faCommentAltDotsSolid,
	faCommentsAltSolid,
	faBellSolid,

	// Pro light
	faPaperPlane,
	faSearch,
	faShare,
	faMapMarkerAltLight,
	faTrashAlt,
	faEllipsisV,
	faUserLight,
	faTimesLight,
	faBookmarkLight,
	faGlobe,
	faCamera,
	faImages,
	faAngleDownLight,
	faSortAmountUpLight,
	faSortAmountDownLight,
	faSortAlphaUpLight,
	faSortAlphaDownLight,
	faLongArrowAltUpLight,
	faLongArrowAltDownLight,
	faCommentAltLinesSolid,
	faArrowAltCircleUpSolid,
	faEmailSolid,
	faEmailLight,
	faCommentsAltLight,
	faCommentAltSmile,
	faArrowUpLight,
	faArrowDownLight,
	faListAltLight,
	faFilePdfLight,
	faCogLight,
	faBuildingLight,
	faAbacusLight,
	faExclamationCircleLight,
	faThumbsUpLight,
	faSignalLight,
	faCheckLight,
	faClockLight,

	// Duo tone
	faCheckCircle,
	faMailBulkDuo,
	faSmsDuo,
	faFileAltDuo,
	faSignalStreamDuo,
	faSatelliteDishDuo,
	faAbacusDuo,
	faCalendarDuo,
	faEmailDuo,
	faFolderUploadDuo,
	faCommentDotsDuo,
	faBrailleDuo,
	faExclamationTriangleDuo,
	faEnvelopeDuo,
	faCommentsDuo
);
